import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SiteNavigationService } from '../../core-services';
import { TranslationService } from '../../translations';

@Component({
    selector: 'page-not-found',
    template: `
        <dashboard class="pi-dashboard--pageNotFound">
            <ng-container dashboard-body>
                <div class="pageNotFoundDescription">
                    <div class="ico-moon ico-moon-spam color-silver"></div>

                    <div class="pageNotFoundDescription_mainLine">
                        {{ TR.key('pageNotFound.header') }}
                    </div>
                    <div class="pageNotFoundDescription_secondaryLine">
                        {{ TR.key('pageNotFound.subheader') }}
                    </div>
                    @if (!isInPlatformApp) {
                        <div>
                            <div
                                class="btn btn--lsg btn--lsg--primary_new"
                                (click)="goToPage()"
                            >
                                {{ TR.key(getButtonName()) }}
                            </div>
                        </div>
                    }
                </div>
            </ng-container>
        </dashboard>
    `,
    standalone: false
})
export class PageNotFoundComponent {
    @Input()
    pageLink: string;

    @Input()
    pageName: string;

    constructor(
        public TR: TranslationService,
        private router: Router,
        public siteNav: SiteNavigationService
    ) {}

    get isInPlatformApp() {
        return this.siteNav.isInPlatform;
    }

    goToPage() {
        this.router.navigate([
            `${this.pageLink ? this.pageLink : `/dashboard`}`
        ]);
    }

    getButtonName() {
        return this.pageName ? this.pageName : 'common.goToDashboard';
    }
}
